import { HttpClient } from "@angular/common/http";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { AlertNotificationService } from "../services/alert-notification.service";
import { timeout } from "rxjs/operators";
import { NestedTreeControl } from "@angular/cdk/tree";
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from "@angular/core";
import { MatTreeNestedDataSource } from "@angular/material/tree";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { DataService } from "../services/data.service";
import { FirestoreService } from "../services/firestore.service";
import { HttpcallsService } from "../services/httpcalls.service";
import * as _ from "lodash";
import { AngularFirestore } from "@angular/fire/firestore";
import * as CryptoJS from "crypto-js";
import  {NgbModal}  from "@ng-bootstrap/ng-bootstrap";
interface FoodNode {
  name: string;
  level?: string;
  index?: number;
  expanded?: boolean;
  disabled?: boolean;
  children?: FoodNode[];
}

const OEE_DATA: FoodNode[] = [
  {
    name: "Sona BLW",
    level: "fleet",
    index: 0,
    expanded: true,
    disabled: false,
  },
  {
    name: "Unit-1,Begumpur Khatola",
    level: "plant",
    index: 0,
    disabled: false,
    expanded: true,
    children: [
      {
        name: "line 1",
        level: "unit",
        expanded: true,
        disabled: false,
        children: [
          { name: "Induction Heater", level: "asset" },
          { name: "Rough Press", level: "asset" },
        ],
      },
    ],
  },
];
const ASSET_HEALTH_DATA: FoodNode[] = [
  {
    name: "Fleet",
    level: "fleet",
    disabled: false,
    expanded: true,
    children: [
      {
        name: "Plant1",
        level: "plant",
        disabled: false,
        expanded: true,
        children: [
          {
            name: "Line 1",
            level: "unit",
            expanded: true,
            children: [
              { name: "Press", level: "asset" },
              { name: "Induction  Heater", level: "asset" },
              { name: "Slow cooling Conveyour", level: "asset" },
            ],
          },
        ],
      },
      {
        name: "Plant2",
        level: "plant",
        disabled: true,
        expanded: false,
        children: [
          {
            name: "Line 1",
            expanded: false,
            level: "unit",
            children: [
              { name: "Press", level: "asset" },
              { name: "Induction  Heater", level: "asset" },
              { name: "Slow cooling Conveyour", level: "asset" },
            ],
          },
        ],
      },
      {
        name: "Plant3",
        disabled: true,
        expanded: false,
        level: "plant",
        children: [
          {
            name: "Line 1",
            level: "unit",
            expanded: false,
            children: [
              { name: "Press", level: "asset" },
              { name: "Induction  Heater", level: "asset" },
              { name: "Slow cooling Conveyour", level: "asset" },
            ],
          },
        ],
      },
      {
        name: "Plant4",
        level: "plant",
        disabled: true,
        expanded: false,
        children: [
          {
            name: "Line 1",
            level: "unit",
            expanded: false,
            children: [
              { name: "Press", level: "asset" },
              { name: "Induction  Heater", level: "asset" },
              { name: "Slow cooling Conveyour", level: "asset" },
            ],
          },
        ],
      },
    ],
  },
];

@Component({
  selector: "app-layout-container",
  templateUrl: "./layout-container.component.html",
  styleUrls: ["./layout-container.component.scss"],
})
export class LayoutContainerComponent implements OnInit, AfterViewInit {
  isSidebarCollapsed: boolean = false;

  toggleSidebar() {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }
  @ViewChild("tree", { static: true }) tree;
  version = environment.version;
  levelId = localStorage.getItem("levelid");
  role = localStorage.getItem("role");
  selectednode = this.levelId;
  treeControl = new NestedTreeControl<FoodNode>((node) => node.children);
  dataSource = new MatTreeNestedDataSource<FoodNode>();
  sidebar: boolean = true;
  selectedModule: string = "assethealth";
  submodule: string = "overview";
  oee = [];
  loading = false;
  searchkey: string;
  db: any;
  activeThem: string = "white";
  switch_color = "#277ef3";
  switch_checked: boolean;
  tab_bar: boolean = true;
  isPredictAI: any;
  twoHourInterval;
  message: any;
  url: any;
  display: string = "none";

  showRoboChat: boolean = false;
  roboCopilotInput: string = '';
  isRoboTyping: boolean = false;
  copilotStatus: 'online' | 'offline' | 'checking' = 'checking';
  isMuted: boolean = false;
  isVoiceListening: boolean = false;
  speechRecognition: any = null;
  voiceBasePrompt: string = '';

  initSpeechRecognition() {
    const SpeechRecognitionClass = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
    if (!SpeechRecognitionClass) {
      console.warn('[Web Speech] Speech recognition not supported in this browser.');
      return;
    }

    try {
      this.speechRecognition = new SpeechRecognitionClass();
      this.speechRecognition.continuous = true;
      this.speechRecognition.interimResults = true;
      this.speechRecognition.lang = (navigator as any).language || 'en-IN';

      this.speechRecognition.onresult = (event: any) => {
        let transcript = '';
        for (let i = 0; i < event.results.length; ++i) {
          transcript += event.results[i][0].transcript;
        }

        const recognizedText = transcript.trim();
        if (recognizedText) {
          this.roboCopilotInput = (this.voiceBasePrompt ? this.voiceBasePrompt + ' ' : '') + recognizedText;
          if (this.cf) this.cf.detectChanges();
        }
      };

      this.speechRecognition.onerror = (event: any) => {
        console.warn('[Web Speech] Error:', event.error);
        if (event.error !== 'no-speech') {
          this.isVoiceListening = false;
        }
        if (this.cf) this.cf.detectChanges();
      };

      this.speechRecognition.onend = () => {
        this.isVoiceListening = false;
        if (this.cf) this.cf.detectChanges();
      };
    } catch (e) {
      console.error('[Web Speech] Initialization error:', e);
    }
  }

  toggleSpeechRecognition() {
    if (!this.speechRecognition) {
      this.initSpeechRecognition();
    }

    if (!this.speechRecognition) {
      alert('Voice dictation is supported in Google Chrome, Microsoft Edge, and modern Chromium browsers. Please ensure microphone access is permitted in your browser settings.');
      return;
    }

    if (this.isVoiceListening) {
      try {
        this.speechRecognition.stop();
      } catch (e) {}
      this.isVoiceListening = false;
    } else {
      try {
        this.voiceBasePrompt = this.roboCopilotInput ? this.roboCopilotInput.trim() : '';
        this.speechRecognition.start();
        this.isVoiceListening = true;
      } catch (e) {
        console.warn('[Web Speech] Start failed:', e);
        this.isVoiceListening = false;
      }
    }
    if (this.cf) this.cf.detectChanges();
  }

  toggleMuteSound() {
    this.isMuted = this.alertNotificationService.toggleMute();
  }

  latestWarnData: any[] = [];
  roboCopilotMessages: any[] = [
    {
      sender: 'ai',
      text: '🤖 Hello! I am Predict.AI RoboCopilot powered by Gemini 2.5 AI. Ask me about machine health, bearing temperatures, alerts, or maintenance!'
    }
  ];

  roboSuggestions: string[] = [
    '🌅 Shift Handover Executive Summary',
    'Which machines need maintenance in proper order?',
    'Why is F-10 Finish Press showing warning & what is the SOP?',
    'Which machine consumes most electricity & why are billets slow?',
    'Calculate power factor capacitor kVAR for F-67 & savings',
    'Where is money leaking and what parts should we replace?'
  ];

  toggleRoboChat() {
    this.showRoboChat = !this.showRoboChat;
    if (this.showRoboChat) {
      this.checkCopilotHealth();
    } else {
      if (this.isVoiceListening && this.speechRecognition) {
        try { this.speechRecognition.stop(); } catch (e) {}
        this.isVoiceListening = false;
      }
    }
  }

  getCopilotUrl(endpoint: string): string {
    const baseUrl = (environment && (environment as any).COPILOT_API) ? (environment as any).COPILOT_API : 'http://localhost:9330';
    return `${baseUrl.replace(/\/$/, '')}${endpoint}`;
  }

  checkCopilotHealth() {
    this.copilotStatus = 'checking';
    this.httpClient.get<any>(this.getCopilotUrl('/api/health')).subscribe(
      (res) => {
        if (res && res.status === 'online') {
          this.copilotStatus = 'online';
        } else {
          this.copilotStatus = 'offline';
        }
      },
      () => {
        this.copilotStatus = 'offline';
      }
    );
  }

  hasWorkOrderSop(text: string): boolean {
    if (!text) return false;
    const lower = text.toLowerCase();
    return (
      lower.includes('sop-') ||
      lower.includes('procedure steps') ||
      lower.includes('spare parts required') ||
      lower.includes('how corrected') ||
      lower.includes('work order') ||
      lower.includes('priority queue')
    );
  }

  downloadWorkOrderPdf(messageText: string) {
    if (!messageText) return;

    const now = new Date();
    const woNumber = 'WO-SONA-' + now.getFullYear() + '-' + Math.floor(1000 + Math.random() * 9000);
    const dateStr = now.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
    const timeStr = now.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' });

    let assetName = 'Forge Line 2 Equipment';
    if (messageText.includes('F-10') || messageText.toLowerCase().includes('finish press')) assetName = 'Finish Press (F-10)';
    else if (messageText.includes('F-09') || messageText.toLowerCase().includes('rough press')) assetName = 'Rough Press (F-09)';
    else if (messageText.includes('SQF08') || messageText.toLowerCase().includes('sqf')) assetName = 'Sealed Quench Furnace (SQF08)';
    else if (messageText.includes('F-67') || messageText.toLowerCase().includes('induction')) assetName = 'Induction Heater 1 (F-67)';

    const cleanText = messageText.replace(/###/g, '').replace(/####/g, '').replace(/\*\*/g, '').trim();

    const printContent = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>Maintenance Work Order - ${woNumber}</title>
        <style>
          @page { size: A4 portrait; margin: 15mm; }
          body { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; color: #1e293b; line-height: 1.5; font-size: 13px; margin: 0; padding: 20px; }
          .header-table { width: 100%; border-bottom: 2px solid #0f172a; padding-bottom: 12px; margin-bottom: 16px; }
          .company-title { font-size: 20px; font-weight: 800; color: #0f172a; text-transform: uppercase; letter-spacing: 0.5px; }
          .doc-badge { display: inline-block; background: #dc2626; color: #ffffff; padding: 4px 10px; font-size: 12px; font-weight: 700; border-radius: 4px; text-transform: uppercase; }
          .meta-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 10px; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 6px; padding: 12px; margin-bottom: 16px; }
          .meta-item { display: flex; flex-direction: column; }
          .meta-label { font-size: 10.5px; font-weight: 700; color: #64748b; text-transform: uppercase; }
          .meta-value { font-size: 13px; font-weight: 600; color: #0f172a; }
          .section-title { font-size: 13px; font-weight: 700; color: #0f172a; margin-top: 14px; margin-bottom: 8px; border-left: 4px solid #2563eb; padding-left: 8px; text-transform: uppercase; }
          .content-box { background: #ffffff; border: 1px solid #e2e8f0; border-radius: 6px; padding: 12px; font-size: 12.5px; white-space: pre-wrap; line-height: 1.6; }
          .safety-box { background: #fffbeb; border: 1px solid #fef3c7; border-left: 4px solid #f59e0b; padding: 10px; border-radius: 4px; margin: 14px 0; font-size: 12px; color: #92400e; }
          .signoff-table { width: 100%; margin-top: 24px; border-collapse: collapse; }
          .signoff-table td { width: 33.33%; border: 1px solid #cbd5e1; padding: 12px 10px; vertical-align: top; }
          .sign-line { border-bottom: 1px dashed #94a3b8; height: 35px; margin-top: 10px; }
          @media print {
            body { padding: 0; }
            button { display: none; }
          }
        </style>
      </head>
      <body>
        <table class="header-table">
          <tr>
            <td>
              <div class="company-title">SONA BLW PRECISION FORGINGS LTD.</div>
              <div style="font-size: 12px; color: #64748b; margin-top: 2px;">Plant Maintenance & Condition Monitoring Division | Unit 1 Gurugram</div>
            </td>
            <td style="text-align: right;">
              <span class="doc-badge">AUTHORIZED WORK ORDER</span>
            </td>
          </tr>
        </table>

        <div class="meta-grid">
          <div class="meta-item"><span class="meta-label">Work Order No.</span><span class="meta-value">${woNumber}</span></div>
          <div class="meta-item"><span class="meta-label">Target Asset</span><span class="meta-value">${assetName}</span></div>
          <div class="meta-item"><span class="meta-label">Issue Date / Time</span><span class="meta-value">${dateStr} ${timeStr}</span></div>
          <div class="meta-item"><span class="meta-label">Priority Level</span><span class="meta-value" style="color: #dc2626;">HIGH / CRITICAL</span></div>
        </div>

        <div class="safety-box">
          <strong>⚠️ MANDATORY SAFETY & COMPLIANCE REQUIREMENTS:</strong><br>
          1. Execute 415V electrical Lockout/Tagout (LOTO) prior to barrier interlock entry.<br>
          2. Mandatory PPE: Impact-resistant eye visor, nitrile chemical gloves, steel-toe boots.<br>
          3. Bleed residual hydraulic/pneumatic accumulator pressure to 0 bar before disassembly.
        </div>

        <div class="section-title">Diagnostic Findings & Corrective Standard Operating Procedure (SOP)</div>
        <div class="content-box">${cleanText}</div>

        <div class="section-title">Execution Sign-Off & Return to Service Verification</div>
        <table class="signoff-table">
          <tr>
            <td>
              <div class="meta-label">Assigned Lead Technician</div>
              <div class="sign-line"></div>
              <div style="font-size: 11px; color: #64748b; margin-top: 4px;">Name & Employee ID</div>
            </td>
            <td>
              <div class="meta-label">Maintenance Shift Supervisor</div>
              <div class="sign-line"></div>
              <div style="font-size: 11px; color: #64748b; margin-top: 4px;">Approval Signature</div>
            </td>
            <td>
              <div class="meta-label">Quality Handover & Clearance</div>
              <div class="sign-line"></div>
              <div style="font-size: 11px; color: #64748b; margin-top: 4px;">Time & Date Completed</div>
            </td>
          </tr>
        </table>
      </body>
      </html>
    `;

    const printWindow = window.open('', '_blank', 'width=850,height=900');
    if (printWindow) {
      printWindow.document.open();
      printWindow.document.write(printContent);
      printWindow.document.close();
      setTimeout(() => {
        printWindow.focus();
        printWindow.print();
      }, 500);
    }
  }

  formatMessageContent(text: string): SafeHtml {
    if (!text) return '';
    let formatted = text;

    // Convert Markdown Tables (| Col1 | Col2 | ...)
    const tableRegex = /((?:\|[^\n]+\|\r?\n)+)/g;
    formatted = formatted.replace(tableRegex, (match) => {
      const rows = match.trim().split(/\r?\n/).map(r => r.trim()).filter(Boolean);
      if (rows.length < 2) return match;
      let html = '<div class="robo-table-wrapper"><table class="robo-table">';
      let isHeader = true;
      for (let i = 0; i < rows.length; i++) {
        const row = rows[i];
        if (/^\|[\s\-:]+(\|[\s\-:]+)+\|$/.test(row)) {
          isHeader = false;
          continue;
        }
        const cells = row.split('|').slice(1, -1).map(c => c.trim());
        if (isHeader) {
          html += '<thead><tr>' + cells.map(c => `<th>${c}</th>`).join('') + '</tr></thead><tbody>';
          isHeader = false;
        } else {
          html += '<tr>' + cells.map(c => `<td>${c}</td>`).join('') + '</tr>';
        }
      }
      html += '</tbody></table></div>';
      return html;
    });

    // Convert markdown headers
    formatted = formatted.replace(/^####\s+(.*)$/gm, '<div class="robo-heading robo-h4">$1</div>');
    formatted = formatted.replace(/^###\s+(.*)$/gm, '<div class="robo-heading robo-h3">$1</div>');
    formatted = formatted.replace(/^##\s+(.*)$/gm, '<div class="robo-heading robo-h2">$1</div>');

    // Convert inline code / metrics `chip`
    formatted = formatted.replace(/`([^`]+)`/g, '<code class="robo-code-chip">$1</code>');

    // Convert bold text **word**
    formatted = formatted.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

    // Convert numbered lists (1. Item)
    formatted = formatted.replace(/^(\d+)\.\s+(.*)$/gm, '<div class="robo-number-item"><span class="robo-num-badge">$1</span> $2</div>');

    // Convert bullet lists starting with • or - or *
    formatted = formatted.replace(/^[•\-\*]\s+(.*)$/gm, '<div class="robo-bullet-item"><span class="robo-bullet-dot">•</span> $1</div>');

    // Convert severity and status tags
    formatted = formatted.replace(/\((Normal|Stable)\)/g, '<span class="badge badge-success">$1</span>');
    formatted = formatted.replace(/\((Slight Trend Upwards|Warning)\)/g, '<span class="badge badge-warning">$1</span>');
    formatted = formatted.replace(/\[Critical\]|Critical alerts/g, '<span class="badge badge-danger">Critical</span>');
    formatted = formatted.replace(/\[Warning\]|Warning/g, '<span class="badge badge-warning">Warning</span>');

    // Formatting headings starting with emoji or title
    formatted = formatted.replace(/^(🌡️|⚡|🎫|⚠️|🤖|🔍|🛠️|📦|💸|🚀|🧮|💡|🎯|📋)\s*(.*?):$/gm, '<div class="robo-heading">$1 $2</div>');

    // Replace double newlines with spacing, single with break
    formatted = formatted.replace(/\n\n/g, '<div class="robo-paragraph-space"></div>');
    formatted = formatted.replace(/\n/g, '<br>');

    return this.sanitizer.bypassSecurityTrustHtml(formatted);
  }

  private getActiveMachineContext(): string {
    const url = this.router ? this.router.url : '';
    if (url.includes('downtime')) return 'Downtime Analytics View';
    if (url.includes('predictive')) return 'Predictive Maintenance Dashboard';
    if (url.includes('monitor')) return 'Realtime Machine Monitor';
    if (url.includes('alerts')) return 'Active Predictive Alerts';

    const selAsset = this.service && this.service.selectedAssset ? this.service.selectedAssset.value : null;
    if (selAsset && typeof selAsset === 'string') return selAsset;
    return 'Line 2 Asset Fleet';
  }

  private scrollChatToBottom() {
    setTimeout(() => {
      const chatBody = document.querySelector('.robo-chat-body');
      if (chatBody) {
        chatBody.scrollTop = chatBody.scrollHeight;
      }
    }, 120);
  }

  sendRoboMessage(userQuery?: string) {
    if (this.isVoiceListening && this.speechRecognition) {
      try { this.speechRecognition.stop(); } catch (e) {}
      this.isVoiceListening = false;
    }

    const text = userQuery || this.roboCopilotInput;
    if (!text || !text.trim()) return;

    const queryText = text.trim();
    this.roboCopilotMessages.push({ sender: 'user', text: queryText });
    this.roboCopilotInput = '';
    this.isRoboTyping = true;
    this.scrollChatToBottom();

    const activeContext = {
      currentRoute: this.router ? this.router.url : '/dashboard',
      activeMachine: this.getActiveMachineContext(),
      selectedAsset: this.service && this.service.selectedAssset ? this.service.selectedAssset.value : null
    };

    this.httpClient.post<any>(this.getCopilotUrl('/api/copilot'), {
      prompt: queryText,
      context: activeContext
    }).pipe(timeout(25000)).subscribe(
      (res) => {
        this.isRoboTyping = false;
        this.copilotStatus = 'online';
        let reply = res && res.reply ? res.reply : 'RoboCopilot is analyzing plant telemetry...';
        this.roboCopilotMessages.push({ sender: 'ai', text: reply });
        this.scrollChatToBottom();
      },
      (err) => {
        this.isRoboTyping = false;
        this.copilotStatus = 'offline';
        let reply = this.generateLocalCopilotResponse(queryText, activeContext);
        this.roboCopilotMessages.push({ sender: 'ai', text: reply });
        this.scrollChatToBottom();
      }
    );
  }

  generateLocalCopilotResponse(queryText: string, context: any): string {
    const q = (queryText || '').toLowerCase();
    const activeMachine = context && context.activeMachine ? context.activeMachine : 'Plant Fleet';

    if (q.includes('hi') || q.includes('hello') || q.includes('hey')) {
      return `Hello! I am Predict.AI RoboCopilot. I am monitoring your plant fleet including Induction Heater, Rough Press, Finish Press, and SQF furnaces. How can I assist you with machine telemetry, alerts, or health today?`;
    }

    if (q.includes('handover') || q.includes('shift') || q.includes('summary')) {
      if (this.latestWarnData && this.latestWarnData.length) {
        const alertHighlights = this.latestWarnData.slice(0, 3).map((a: any) => {
          const m = a.asset || a.assetcode || 'Machine';
          const msg = a.warnmsg || a.description || 'Threshold exceeded';
          return `• **${m}**: ${msg}`;
        }).join('\n');
        return `📋 **Shift Handover Executive Summary**:\n• Total Active Alerts in Firestore: ${this.latestWarnData.length} records.\n• Active Exceptions:\n${alertHighlights}\n• Operating Guidance: Review priority maintenance tickets for flagged assets.`;
      } else {
        return `📋 **Shift Handover Executive Summary**:\n• Fleet Status: All operational lines running nominally.\n• Active Alerts: 0 critical stoppage warnings in database.\n• Telemetry: Systems streaming live data.`;
      }
    }

    if (q.includes('alert') || q.includes('warn') || q.includes('critical')) {
      if (this.latestWarnData && this.latestWarnData.length) {
        const uniqueAlerts: any[] = [];
        const seen = new Set<string>();
        for (const a of this.latestWarnData) {
          const key = (a.asset || a.assetcode || '') + '|' + (a.warnmsg || a.description || a.tag || '');
          if (!seen.has(key)) {
            seen.add(key);
            uniqueAlerts.push(a);
          }
          if (uniqueAlerts.length >= 6) break;
        }

        const lines = uniqueAlerts.map((a: any) => {
          const m = a.asset || a.assetcode || 'Machine';
          const msg = a.warnmsg || a.description || (a.parameter ? (a.parameter + ' limit exceeded') : 'Threshold limit exceeded');
          const val = a.value !== undefined ? ' (Reading: ' + a.value + ')' : '';
          const prio = a.priority ? ' [' + a.priority + ']' : '';
          return '• **' + m + '**: ' + msg + val + prio;
        });

        return '⚠️ **Active Plant Alerts Summary (' + this.latestWarnData.length + ' Total in Database)**:\n' +
          lines.join('\n') +
          '\n\nAll alerts are synchronized in real-time with Cloud Firestore (/Asset_OEE/SONA/WarnData).';
      } else {
        return '✅ **Active Plant Alerts Summary**:\nAll monitored plant machines are currently operating within normal parameters. There are 0 active warnings in Firestore (/Asset_OEE/SONA/WarnData).';
      }
    }

    if (q.includes('sqf09')) {
      const sqf09 = this.latestWarnData.find((a: any) => (a.asset && a.asset.includes('SQF09')) || (a.assetcode && a.assetcode.includes('SQF09')));
      const detail = sqf09 ? (sqf09.warnmsg || sqf09.description || ('Critical threshold reached (' + (sqf09.value || '906.6') + ')')) : 'Critical Threshold exceeded (Reading: 906.6)';
      return `🔍 **SQF09 Diagnostic Report**:\n• Status: Alert active in Cloud Firestore (/Asset_OEE/SONA/WarnData).\n• Finding: ${detail}\n• Guidance: Check sensor calibration and atmosphere reference setpoints.`;
    }

    if (q.includes('sqf07') || q.includes('zirconia')) {
      const sqf07 = this.latestWarnData.find((a: any) => (a.asset && a.asset.includes('SQF07')) || (a.assetcode && a.assetcode.includes('SQF07')));
      const detail = sqf07 ? (sqf07.warnmsg || sqf07.description || 'Zirconia Milivolt value exceeded') : 'Zirconia Sensor voltage (1050 mV) exceeds upper warning threshold (1000 mV)';
      return `🔍 **SQF07 Diagnostic Report**:\n• Sensor: Zirconia Oxygen Sensor (Atmosphere Control)\n• Status: Alert active in Cloud Firestore (/Asset_OEE/SONA/WarnData).\n• Finding: ${detail}\n• Guidance: Potential carbon potential drift or sensor degradation. Verify reference air flow.`;
    }

    if (q.includes('health') || q.includes('status') || q.includes('state')) {
      return `📊 **${activeMachine} Telemetry Health**:\n• Operational State: ON\n• Reliability Score: 98.5% (Optimal Condition)\n• Vibration & Bearing Frequencies: Within acceptable tolerance band.\n• Subsystem telemetry channels are active.`;
    }

    return `🤖 **RoboCopilot Analysis for ${activeMachine}**:\nOperating nominally. Live telemetry is streaming normally across all monitored tags. Ask me about specific machine health, active alerts, or maintenance shift handover!`;
  }

  constructor(
    private router: Router,
    private service: DataService,
    private http: HttpcallsService,
    private firestore: AngularFirestore,
    private fs: FirestoreService,
    private route: ActivatedRoute,
    private cf: ChangeDetectorRef,
    private httpClient: HttpClient,
    private sanitizer: DomSanitizer,
    private alertNotificationService: AlertNotificationService
  ) // private modalService: NgbModal
  {}
  ngOnInit() {
    this.service.loader.subscribe((data: any) => {
      this.loading = data;
      this.cf.detectChanges();
    });
    let project = JSON.parse(sessionStorage.getItem("isPredictAI"));
    this.isPredictAI = project != undefined ? project : true;
    if (this.activeThem == "white") {
      this.switch_checked = true;
    } else {
      this.switch_checked = false;
    }
    this.db = this[environment.SERVICE_CALL];
    this.service.selectednode2.subscribe((data: any) => {
      if (!data || Object.keys(data).length == 0) {
        try {
          data = JSON.parse(localStorage.getItem("selectedNode2") || '{}');
        } catch (e) {
          data = {};
        }
      }
      this.selectednode = data && data.id ? data.id : "Sona BLW";
    });
    let params = {
      customerId: "",
    };
    // if (localStorage.getItem("selected")) {
    //   if (localStorage.getItem("selected") == "assethealth") {
    //     params.customerId = "SONA";
    //     this.selectednode = localStorage.getItem("selectednode");
    //   }
    //   this.getCustomer(params);
    // }
    // if (this.service.selectednode != undefined) {
    //   this.service.selectednode.subscribe((data) => {
    //     this.selectednode = data;
    //   });
    // }
    // if (this.service.activatedmodule != undefined) {
    //   this.service.activatedmodule.subscribe((data) => {
    //     this.selectedModule = data;
    //   });
    // }
    if (this.service.activatedsubmodule != undefined) {
      this.service.activatedsubmodule.subscribe((data) => {
        this.submodule = data;
      });
    }
    if (localStorage.getItem("submodule")) {
      this.submodule = localStorage.getItem("submodule");
    }
    this.service.show_navbars.subscribe((data) => {
      this.sidebar = data.sidebar;
      this.tab_bar = data.tabbar;
      this.cf.detectChanges();
    });
    // this.twoHourInterval = setInterval(() => {
    //   this.show_message();
    // }, 5000);
  }
  toggleThem(value) {
    if (value == false) {
      this.service.setActiveThem("black");
      this.activeThem = "black";
    } else {
      this.service.setActiveThem("white");
      this.activeThem = "white";
    }
  }
  getCustomer(params) {
    this.db.getCustomer(params).subscribe((data: any) => {
      if (environment.SERVICE_CALL == "fs") {
        this.formattedData(data);
      } else {
        this.oee.push(data.data);
        this.dataSource.data = this.oee;
        this.calhierarchy(this.oee);
      }
      if (this.oee[0].expanded != undefined) {
        this.service.send_h_data(this.oee);
      }
      this.service.getheiratchydata.subscribe((h_data: FoodNode[]) => {
        this.dataSource.data = [];
        this.dataSource.data = h_data;
      });
    });
  }
  formattedData(data) {
    let customerData: any[] = [];
    let documents = [];
    this.dataSource.data = [];
    this.oee = [];
    data.forEach((element) => {
      documents.push(element.data());
    });
    if (documents && documents.length > 0) {
      let obj = {};
      obj["id"] = documents[0].customerId;
      obj["name"] = documents[0].customer;
      obj["level"] = "fleet";
      obj["index"] = 0;
      customerData[0] = obj;
      let siteNum = 0;
      _.forOwn(_.groupBy(documents, "siteId"), (value, key) => {
        siteNum++;
        var siteData = {
          id: key,
          name: value[0].site,
          level: "plant",
        };
        _.forOwn(_.groupBy(value, "lineId"), (value, key) => {
          var lineData = {
            id: key,
            name: value[0].line,
            level: "unit",
          };
          _.forOwn(_.groupBy(value, "assetcode"), (value, key) => {
            var assetData = {
              id: key,
              level: "asset",
              name: value[0].asset,
            };
            if (!lineData["children"]) {
              lineData["children"] = [assetData];
            } else {
              lineData["children"].push(assetData);
            }
          });
          if (!siteData["children"]) {
            siteData["children"] = [lineData];
          } else {
            siteData["children"].push(lineData);
          }
        });
        customerData[siteNum] = siteData;
        customerData[1]["index"] = 0;
      });
      if (this.role == "fleet") {
        this.oee = customerData;
        this.dataSource.data = this.oee;
        this.calhierarchy(customerData);
      } else {
        this.requiredData(customerData);
      }
    }
  }
  requiredData(data) {
    let result;
    data.forEach((d) => {
      if (d.id == this.levelId && d.level == this.role) {
        result = d;
        this.oee.push(result);
        this.dataSource.data = this.oee;
        this.calhierarchy(this.oee);
      } else {
        if (d.children) {
          this.requiredData(d.children);
        }
      }
    });
  }
  calhierarchy(data) {
    data.forEach((asset) => {
      if (asset.children != undefined && asset.children.length > 0) {
        asset["expanded"] = true;
        asset["disable"] = false;
        this.calhierarchy(asset.children);
      } else {
        if (this.role == "site manager") {
          asset["disable"] = false;
        }
        let node = JSON.parse(localStorage.getItem("selectednode"));
        this.navigate(node);
      }
    });
  }
  ngAfterViewInit() {}
  hasChild = (_: number, node: FoodNode) =>
    !!node.children && node.children.length > 0;
  logNode(node?) {
    if (!node.disabled) {
      let level = node.level;
      if (
        node.level == "assettype" ||
        node.level == "unittype" ||
        node.level == "planttype"
      ) {
        if (node.children != undefined) {
          this.navigate(node.children[0]);
        }
      } else {
        this.navigate(node);
      }
    }
  }
  navigate(node) {
    let level = node.level;
    if (level == "asset") {
      localStorage.setItem("activate_tab", JSON.stringify(false));
    } else {
      localStorage.setItem("activate_tab", JSON.stringify(true));
    }
    this.service.sendselectednode2(node);
    localStorage.setItem("selectednode", JSON.stringify(node));
    if (level == "plant" && this.selectedModule == "oee") {
      if (this.submodule == "dashboard") {
        this.router.navigateByUrl(
          "/common/oee/oee/dashboard/plant-level-dashboard"
        );
      } else if (this.submodule == "availability") {
        this.router.navigateByUrl(
          "/common/oee/oee/availability/plant-level-availability"
        );
      } else if (this.submodule == "performance") {
        this.router.navigateByUrl(
          "/common/oee/oee/performance/plant-level-performance"
        );
      } else if (this.submodule == "quality") {
        this.router.navigateByUrl(
          "/common/oee/oee/quality/plant-level-quality"
        );
      }
    } else if (level == "unit" && this.selectedModule == "oee") {
      if (this.submodule == "dashboard") {
        this.router.navigateByUrl(
          "/common/oee/oee/dashboard/unit-level-dashboard"
        );
      } else if (this.submodule == "availability") {
        this.router.navigateByUrl(
          "/common/oee/oee/availability/unit-level-availability"
        );
      } else if (this.submodule == "performance") {
        this.router.navigateByUrl(
          "/common/oee/oee/performance/unit-level-performance"
        );
      } else if (this.submodule == "quality") {
        this.router.navigateByUrl("/common/oee/oee/quality/unit-level-quality");
      }
    } else if (level == "asset" && this.selectedModule == "oee") {
      if (this.submodule == "dashboard") {
        this.router.navigateByUrl(
          "/common/oee/oee/dashboard/asset-level-dashboard"
        );
      } else if (this.submodule == "availability") {
        this.router.navigateByUrl(
          "/common/oee/oee/availability/asset-level-availability"
        );
      } else if (this.submodule == "performance") {
        this.router.navigateByUrl(
          "/common/oee/oee/performance/asset-level-performance"
        );
      } else if (this.submodule == "quality") {
        this.router.navigateByUrl(
          "/common/oee/oee/quality/asset-level-quality"
        );
      }
    } else if (level == "fleet" && this.selectedModule == "oee") {
      if (this.submodule == "dashboard") {
        this.router.navigateByUrl(
          "/common/oee/oee/dashboard/fleet-level-dashboard"
        );
      } else if (this.submodule == "availability") {
        this.router.navigateByUrl(
          "/common/oee/oee/availability/fleet-level-availability"
        );
      } else if (this.submodule == "performance") {
        this.router.navigateByUrl(
          "/common/oee/oee/performance/fleet-level-performance"
        );
      } else if (this.submodule == "quality") {
        this.router.navigateByUrl(
          "/common/oee/oee/quality/fleet-level-quality"
        );
      }
    } else if (level == "fleet" && this.selectedModule == "assethealth") {
      if (this.submodule == "overview") {
        this.router.navigateByUrl(
          "/common/predictive-maintenance/pm/fleet-level-overview"
        );
      } else if (this.submodule == "indicators") {
        this.router.navigate(["/common/predictive-maintenance/pm/indicators"]);
      } else if (this.submodule == "alerts") {
        this.router.navigate(["common/predictive-maintenance/pm/alerts/alert"]);
      }
    } else if (level == "plant" && this.selectedModule == "assethealth") {
      if (this.submodule == "overview") {
        this.router.navigateByUrl(
          "/common/predictive-maintenance/pm/plant-level-overview"
        );
      } else if (this.submodule == "indicators") {
        this.router.navigate(["/common/predictive-maintenance/pm/indicators"]);
      } else if (this.submodule == "alerts") {
        this.router.navigate(["common/predictive-maintenance/pm/alerts/alert"]);
      }
    } else if (level == "unit" && this.selectedModule == "assethealth") {
      if (this.submodule == "overview") {
        this.router.navigateByUrl(
          "/common/predictive-maintenance/pm/line-level-overview"
        );
      } else if (this.submodule == "indicators") {
        this.router.navigate(["/common/predictive-maintenance/pm/indicators"]);
      } else if (this.submodule == "alerts") {
        this.router.navigate(["common/predictive-maintenance/pm/alerts/alert"]);
      }
    } else if (level == "asset" && this.selectedModule == "assethealth") {
      if (this.submodule == "overview") {
        if (node.name == "Induction Heater") {
          this.router.navigateByUrl(
            "/common/predictive-maintenance/pm/asset-level-overview"
          );
        } else if (node.name == "Rough Press" || node.name == "Finish Press") {
          this.router.navigate([
            "/common/predictive-maintenance/pm/press-asset-overview",
            node.id,
          ]);
        } else if (node.name == "Dilute System") {
          this.router.navigateByUrl(
            "/common/predictive-maintenance/pm/dilute-system"
          );
        } else if (node.name == "Slow cooling conveyer") {
          this.router.navigateByUrl(
            "/common/predictive-maintenance/pm/cooling-conveyor"
          );
        }
      } else if (this.submodule == "indicators") {
        this.router.navigate(["/common/predictive-maintenance/pm/indicators"]);
      } else if (this.submodule == "alerts") {
        this.router.navigate(["common/predictive-maintenance/pm/alerts/alert"]);
      }
    }
  }
  changeState(node) {
    node.expanded = !node.expanded;
  }
  sidenavtoggle() {
    setTimeout(() => {
      this.sidebar = false;
      this.tab_bar = false;
    }, 0);
  }
  logout() {
    this.router.navigate(["/login"]);
    localStorage.clear();
    sessionStorage.clear();
  }
  // search
  onkeyup(value: string): void {
    this.dataSource.data = this.search(this.oee, value);
  }
  search(items: FoodNode[], term: string): any[] {
    return items.reduce((acc, item) => {
      if (this.contains(item.name, term)) {
        acc.push(item);
      } else if (item.children && item.children.length > 0) {
        const newItems = this.search(item.children, term);
        if (newItems.length > 0) {
          acc.push({ name: item.name, children: newItems, expanded: true });
        }
      }
      return acc;
    }, []);
  }
  public contains(text: string, term: string): boolean {
    return text.toLowerCase().indexOf(term.toLowerCase()) >= 0;
  }
  clearSearch() {
    this.searchkey = "";
    this.dataSource.data = this.oee;
  }
  set(keys, value) {
    var key = CryptoJS.enc.Utf8.parse(keys);
    var iv = CryptoJS.enc.Utf8.parse(keys);
    var encrypted = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse("" + value.toString()),
      key,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    return encrypted.toString();
  }
  loginTo() {
    this.service.activateloader(true);
    if (this.isPredictAI) {
      this.isPredictAI = !this.isPredictAI;
      const useremail = "adminblp@assethealth.com";
      const password = "123456";
      let encrypted = this.set("123456$#@$^@1ERF", password);
      this.firestore
        .collection("/ConserveAI_Users", (ref) =>
          ref
            .where("useremail", "==", useremail)
            .where("password", "==", encrypted)
        )
        .get()
        .subscribe(
          (data) => {
            this.service.activateloader(false);
            if (data.size == 1) {
              let userCollection;
              data.forEach((element) => {
                userCollection = element.data();
              });
              // console.log(userCollection);
              sessionStorage.setItem("isLoggedIn", JSON.stringify(true));
              sessionStorage.setItem("site", userCollection.site);
              sessionStorage.setItem("user", userCollection.username);
              sessionStorage.setItem("customer", userCollection.organisation);
              sessionStorage.setItem("department", userCollection.department);
              sessionStorage.setItem("useremail", userCollection.useremail);
              sessionStorage.setItem("landing", "/portfolio");
              sessionStorage.setItem("role", userCollection.role);
              sessionStorage.setItem("services", userCollection.services);
              sessionStorage.setItem("uid", userCollection.customer_id);
              // Set the user ID using signed-in user_id.
              this.router.navigate(["common/conserve-ai", "energy-meters"]);
            } else {
              alert("Do not have Access!");
            }
          },
          (err) => {
            this.service.activateloader(false);
            alert("Do not have Access!");
          }
        );
    } else {
      this.isPredictAI = !this.isPredictAI;
      this.router.navigate(["/common/predictive-maintenance/pm/overview"]);
    }
    sessionStorage.setItem("isPredictAI", JSON.stringify(this.isPredictAI));
    this.service.activateloader(false);
  }
  async show_message() {
    let prev_months = {
      address: `/site_url_change`,
      conditions: [],
      type: "history",
    };
    if ((this.display != "block")) {
      let response: any = await this.fs.getFireBaseData(prev_months);
      if (response.status && response.status == "success") {
        this.message = response["data"][0]["message"];
        this.url = response["data"][0]["new_url"];
        this.display = "block";
      }
    }
  }
   navigate_back(){
    this.router.navigate(['/login'])
    this.display='none'
    clearInterval(this.twoHourInterval)
   }
}
